import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "primeicons/primeicons.css";
import PrimeVue from "primevue/config";

// 引入全局组件
import BaseButton from "./components/global/BaseButton.vue";
import BaseInput from "./components/global/BaseInput.vue";
import BaseModal from "./components/global/BaseModal.vue";
import SideBar from "./components/global/SideBar.vue";

import "primevue/resources/themes/saga-blue/theme.css"; // 主题样式
import "primevue/resources/primevue.min.css"; // 核心样式
import "primeicons/primeicons.css"; // 图标
import mitt from "mitt";

// 创建 Vue 应用实例
const app = createApp(App);
app.config.globalProperties.$bus = mitt(); // 添加事件总线

// 使用 Vuex 和 Vue Router
app.use(store);
app.use(router);
app.use(PrimeVue);

// 注册全局组件
app.component("base-button", BaseButton);
app.component("base-input", BaseInput);
app.component("base-modal", BaseModal);
app.component("side-bar", SideBar);

// 挂载 Vue 应用实例到 DOM
app.mount("#app");
